/**
 * Utility functions to capture metadata for signature fields
 */

/**
 * Detect device type from user agent
 */
export const detectDeviceType = () => {
  const ua = navigator.userAgent.toLowerCase();
  
  if (/tablet|ipad|playbook|silk/i.test(ua)) {
    return 'Tablet';
  }
  
  if (/mobile|iphone|ipod|android|blackberry|opera|mini|windows\sce|palm|smartphone|iemobile/i.test(ua)) {
    return 'Mobile';
  }
  
  if (/macintosh|mac os x/i.test(ua)) {
    return 'Desktop (Mac)';
  }
  
  if (/windows/i.test(ua)) {
    return 'Desktop (Windows)';
  }
  
  if (/linux/i.test(ua)) {
    return 'Desktop (Linux)';
  }
  
  return 'Desktop (Unknown)';
};

/**
 * Get approximate location using browser geolocation API
 * Returns null if permission denied or unavailable
 */
export const getLocation = () => {
  return new Promise((resolve) => {
    if (!navigator.geolocation) {
      resolve(null);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          accuracy: position.coords.accuracy, // in meters
          timestamp: new Date(position.timestamp).toISOString()
        });
      },
      (error) => {
        // Permission denied or error - silently fail
        resolve(null);
      },
      {
        enableHighAccuracy: false,
        timeout: 5000,
        maximumAge: 60000 // Accept cached location up to 1 minute old
      }
    );
  });
};

/**
 * Get client metadata (device type, location)
 * IP address will be added by backend
 */
export const getClientMetadata = async () => {
  const deviceType = detectDeviceType();
  const location = await getLocation();
  
  return {
    deviceType,
    userAgent: navigator.userAgent,
    screenResolution: `${window.screen.width}x${window.screen.height}`,
    timestamp: new Date().toISOString(),
    location: location || null
  };
};

